<template>
  <footer>
    <section
      class="footer-area"
      v-if="isDetails"
    >
      <div class="ocean">
        <div class="wave"></div>
        <div class="wave"></div>
      </div>
      <div class="footer-content">
        <div class="row-top">
          <div class="big-xuexi">
            <div class="footer-widget">
              <a href="/">
                <img
                  src="@/image/index/logo-header.png"
                  alt="回车课堂"
                  class="footer__logo"
                />
              </a>
              <ul class="footer-social">
                <li style="display: block">
                  <a class="no-underline" href="/about/" target="_blank">
                    <div class="about-us-btn">
                      <img src="@/image/icon-about-us-btn.png" alt="" />
                      <span>关于我们</span>
                    </div>
                  </a>
                </li>
                <li style="display: block; margin-top: 20px">
                  <a
                    class="no-underline"
                    href="https://www.wjx.cn/vj/wu9pCKB.aspx"
                    target="_blank"
                  >
                    <div class="teacher-recruit-btn">
                      <img src="@/image/icon-recruit-btn.png" alt="" />
                      <span>讲师招聘</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <!-- <div class="menu-bottom">
            <div class="footer-widget">
              <h3 class="footer-title">学科</h3>
              <span class="section__divider"></span>
              <ul class="footer-link">
                <li v-for="(item,index) in menuList" :key="index"><a  style="cursor:default;" target="_blank">{{item.menuName}}</a></li>
              </ul>
            </div>
          </div> -->
          <!-- <div class="col-lg-3 col-sm-6 small-xuexi">
            <div class="footer-widget">
              <h3 class="footer-title">其他学习平台</h3>
              <span class="section__divider"></span>
              <ul class="footer-link">
                <li>
                  <a href="https://www.boxuegu.com"
                    ><img src="@/image/index/logo-bxg-footer.png" alt="博学谷"
                  /></a>
                </li>
              </ul>
            </div>
          </div> -->
          <div class="gzh-bottom">
            <div class="footer-widget">
              <h3 class="footer-title">公众号</h3>
              <span class="section__divider"></span>
              <img class="footer-img" src="@/image/course/gzh-qrcode.jpg" alt="回车课堂公众号">
            </div>
          </div>
          <div class="xcx-bottom">
            <div class="footer-widget">
              <h3 class="footer-title">小程序</h3>
              <span class="section__divider"></span>
              <img class="footer-img" src="@/image/course/xcx-qrcode.jpg" alt="回车课堂小程序">
            </div>
          </div>
        </div>
        <div class="row-text">
          <div class="bottom-info">
            <p><a href="https://www.boxuegu.com">博学谷</a>旗下互动学习平台</p>
            <p class="copy__desc">意见反馈邮箱：hdketang@itcast.cn</p>
          </div>
        </div>
      </div>
    </section>
    <section class="footer" v-else>
      <p>回车课堂 · 意见反馈邮箱：hdketang@itcast.cn</p>
    </section>
  </footer>
</template>

<script>
import { axios } from "@/../api/init";
export default {
  name: "",
  data() {
    return {
      isDetails: false,
      routerArr: [
        "course",
        "detailsPage",
        "index",
        "sceneDetails",
        "scene",
        "about",
        "multiplex",
        "search",
      ], // 需要显示详细底部的页面
      menuList: [],
    };
  },
  mounted() {
    if (this.routerArr.indexOf(this.$route.name) != -1) {
      this.isDetails = true;
      this.getSubjectList();
    }
  },
  methods: {
    // 获取学科
    getSubjectList() {
      axios({
        url: VUE_APP_BASE_PATH_ONLINE_APP + "/interactive-course/menus",
        method: "GET",
      }).then((res) => {
        let data = res.data;
        if (data.status === 200) {
          this.menuList = data.result;
          if (this.menuList && this.menuList.length > 0) {
            // 默认选中第一个
            this.menuList.forEach((val) => {
              val.type = false;
            });
            this.menuList[0].type = true;
          }
        }
      });
    },
    // 学科跳转
    toCourse(res) {
      window.open("/course?menuId=" + res.menuId);
    },
  },
  watch: {
    $route(val) {
      if (this.routerArr.indexOf(val.name) != -1) {
        this.isDetails = true;
        this.getSubjectList();
      } else {
        this.isDetails = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.footer-area {
  position: relative;
  padding-bottom: 24px;
  padding-top: 230px;
  z-index: 1;
  overflow: hidden;
}
@media only screen and (max-width: 767px) {
  .footer-area {
    padding-top: 50px;
    background-color: #233d63;
  }
}

// 波浪动画
.footer-area .ocean {
  height: calc(100% - 230px);
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #233d63;
}
@media only screen and (max-width: 767px) {
  .footer-area .ocean {
    display: none;
  }
}
.footer-area .ocean .wave {
  background: url(../../image/index/wave.svg) repeat-x;
  position: absolute;
  top: -198px;
  width: 6400px;
  height: 350px;
  -webkit-animation: wave 55s cubic-bezier(0.36, 0.45, 0.63, 0.93) infinite;
  animation: wave 55s cubic-bezier(0.36, 0.45, 0.63, 0.93) infinite;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.footer-area .ocean .wave:nth-of-type(2) {
  top: -175px;
  -webkit-animation: wave 55s cubic-bezier(0.36, 0.45, 0.63, 0.93) -0.125s infinite,
    swell 55s ease -1.25s infinite;
  animation: wave 55s cubic-bezier(0.36, 0.45, 0.63, 0.93) -0.125s infinite,
    swell 55s ease -1.25s infinite;
  opacity: 1;
}


// 具体内容
.footer-area{
  .footer-content{
    position: relative;
    max-width: 1200px;
    padding: 0 15px;
    box-sizing: border-box;
    margin: 0 auto;
    z-index:1;
    // 上半部分
    .row-top{
      display: flex;
      justify-content: space-between;
      .big-xuexi{
        flex: 1;
        .footer__logo{
          height: 28px;
        }
        .footer-social{
          margin-top: 25px;
          li {
            display: inline-block;
            margin-right: 2px;
            a {
              display: block;
              text-align: center;
              width: 160px;
              height: 50px;
              -webkit-border-radius: 4px;
              -moz-border-radius: 4px;
              border-radius: 4px;
              background-color: #3f5070;
              padding: 9px 0;
              text-align: center;
              .about-us-btn,
              .teacher-recruit-btn {
                width: 100%;
                height: 100%;
                line-height: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                span {
                  font-size: 18px;
                  line-height: 50px;
                  margin-left: 10px;
                  color: #abb0c0;
                  text-decoration: none;
                }
                img {
                  width: 20px;
                  height: 20px;
                }
              }
              .teacher-recruit-btn {
                img {
                  width: 18px;
                  height: 20px;
                }
              }
              &:hover {
                background-color: #5b729f;
              }
            }
          }
          li:last-child {
            margin-right: 0;
          }
        }
      }
      .xcx-bottom{
        margin-left: 50px;
      }

      // 公共样式
      .footer-widget{
        .footer-title{
          text-transform: capitalize;
          font-weight: 600;
          position: relative;
          margin-bottom: 20px;
          font-size: 24px;
          color: #fff;
        }
        .section__divider{
          display: inline-block;
          position: relative;
          height: 5px;
          border-radius: 30px;
          background-color: #9ea6ba;
          width: 50px;
          margin-bottom: 32px;
          overflow: hidden;
          &:after {
            content: "";
            position: absolute;
            left: 0;
            top: -0.1px;
            height: 5px;
            width: 5px;
            background-color: #fff;
            -webkit-animation-duration: 3s;
            animation-duration: 3s;
            -webkit-animation-timing-function: linear;
            animation-timing-function: linear;
            -webkit-animation-iteration-count: infinite;
            animation-iteration-count: infinite;
            -webkit-animation-name: MOVE-BG2;
            animation-name: MOVE-BG2;
          }
        }
        .footer-img{
          width: 120px;
          height: 120px;
          display: block;
          border-radius: 4px;
        }
      }
    }
    // 下半部分
    .row-text{
      margin-top: 40px;
      padding-top: 24px;
      border-top: 1px solid hsla(0,0%,100%,.1);
      .bottom-info {
        width: 100%;
        display: flex;
        justify-content: space-between;
        p {
          color: #9fa6b8;
          line-height: 22px;
          font-size: 16px;
          a {
            padding-right: 3px;
            color: #9fa6b8;
            text-decoration: underline;
            &:hover {
              color: #25c48b;
            }
          }

        }
      }
    }
  }
}





/*=== 底部的动画 ===*/
@-webkit-keyframes wave {
  0% {
    margin-left: 0;
  }
  100% {
    margin-left: -1600px;
  }
}

@keyframes wave {
  0% {
    margin-left: 0;
  }
  100% {
    margin-left: -1600px;
  }
}

@-webkit-keyframes swell {
  0%,
  100% {
    -webkit-transform: translate3d(0, -25px, 0);
    transform: translate3d(0, -25px, 0);
  }
  50% {
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0);
  }
}

@keyframes swell {
  0%,
  100% {
    -webkit-transform: translate3d(0, -25px, 0);
    transform: translate3d(0, -25px, 0);
  }
  50% {
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0);
  }
}

@-webkit-keyframes MOVE-BG2 {
  from {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  to {
    -webkit-transform: translateX(48px);
    transform: translateX(48px);
  }
}

@-webkit-keyframes MOVE-BG2 {
  from {
    -ms-transform: translateX(0);
    transform: translateX(0);
  }
  to {
    -ms-transform: translateX(48px);
    transform: translateX(48px);
  }
}

@keyframes MOVE-BG2 {
  from {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  to {
    -webkit-transform: translateX(48px);
    transform: translateX(48px);
  }
}



// 部分页面的底部样式
.footer {
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 30px 20px;
  color: #9fa6b8;
  text-align: center;
  line-height: 80px;
  background: #2a3c60;
  z-index: 1;
  p {
    line-height: 20px;
    font-size: 14px;
    text-align: center;
    margin: 0;
  }
}


@media (max-width: 1199px) {
  .container {
    width: 100% !important;
    max-width: 100% !important;
  }
}

@media (max-width: 575px) {
  .footer-area {
    .gzh-bottom,
    .xcx-bottom {
      display: none !important;
    }
    .menu-bottom {
      .footer-link {
        display: flex;
        flex-flow: row wrap;
        li {
          margin-right: 30px;
        }
      }
    }
  }
}

// 不要下划线
.no-underline {
  text-decoration: none !important;
}
</style>